<template>
  <v-container
    id="reference-term-list"
  >
    <v-row>
      <v-col
        cols="8"
        md=8
        class="breadcrumbs"
      >
        <v-breadcrumbs :items="breadcrumbs" :large="true" :divider="'>'">
        </v-breadcrumbs>
      </v-col>

      <v-col
        cols="4"
        sm="4"
      >
        <div class="text-right">
          <div cols="10" md="1">
            <app-modal-insert-task
              :edit="false"
              :color="'success'"
              :icon="'mdi-plus-circle'"
              :filter="filter"
              @onSaveTask="$emit('reloadTasks')"
            >
              <template v-slot:title>
                Cadastramento de Tarefa
              </template>
            </app-modal-insert-task>
          </div>
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="tasks"
          item-key="name"
          class="elevation-1"
        >
          <template v-slot:item.acoes="{ item }">

            <v-row>
              <v-col
              cols="1"
              >
                <app-modal-insert-task
                  :object="item"
                  :edit="true"
                  :color="'warning'"
                  :icon="'mdi-pencil'"
                  :filter="filter"
                  @on-save="$emit('reloadTasks')"
                >
                  <template v-slot:title>
                    Edição de Tarefa
                  </template>
                </app-modal-insert-task>
              </v-col>

              <v-col
                cols="1"
              >
                <app-modal-delete-task
                  :payload="item"
                  @on-save="$emit('reloadTasks')"
                >
                  <template v-slot:title>
                    Deletar Tarefa
                  </template>
                </app-modal-delete-task>
              </v-col>
            </v-row>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AppModalInsertTask from './ModalInsert'
import AppModalDeleteTask from './ModalDelete'

export default {
  name: 'AppTaskList',
  components: {
    AppModalInsertTask,
    AppModalDeleteTask
  },
  props: {
    filter: { type: Object, required: true },
    tasks: { type: Array, required: true }
  },
  data () {
    return {
      headers: [
        {
          text: '#',
          value: 'eixoId',
          sortable: false
        },
        {
          text: 'Nome',
          align: 'left',
          value: 'nome'
        },
        {
          text: 'Descricao',
          value: 'descricao'
        },
        {
          text: 'Solução',
          value: 'solucao.nome'
        },
        {
          text: 'Ações',
          value: 'acoes',
          sortable: false
        }
      ],
      breadcrumbs: [
        {
          text: 'Grupos de Soluções',
          disabled: true,
          href: 'termo-referencia'
        },
        {
          text: 'Soluções',
          disabled: true,
          href: 'termo-referencia'
        },
        {
          text: 'Tarefas',
          disabled: true,
          href: 'termo-referencia'
        }
      ]
    }
  }
}
</script>

<style lang="scss">@import './style.scss';</style>
